import type { ReactNode } from 'react';
import type { PublicUser } from '@awwyeah/shared';

export interface ProfileCardProps {
  user: PublicUser;
  /** Optional trailing content, e.g. a "sign out" button, kept out of this component. */
  action?: ReactNode;
}

/** Minimal member profile card: colour swatch + avatar emoji + name/email. */
export function ProfileCard({ user, action }: ProfileCardProps): JSX.Element {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-line bg-surface p-4 shadow-sm">
      <span
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-2xl"
        style={{ backgroundColor: `${user.color}22`, border: `2px solid ${user.color}` }}
        aria-hidden="true"
      >
        {user.avatarEmoji ?? '👤'}
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate font-semibold text-fg">{user.name}</p>
        <p className="truncate text-sm text-fg-3">{user.email}</p>
      </div>
      {action}
    </div>
  );
}
